module.exports = __webpack_public_path__ + "img/ico.c7be5ce3.svg";